// extracted by mini-css-extract-plugin
module.exports = {"cls1":"JsDocMembers-CssProp1_li-module--cls1--WWdwA","cls2":"JsDocMembers-CssProp1_li-module--cls2--_9_1b JsDocMembers-CssProp1_li-module--cls1--WWdwA"};